<template>
  <div>
    <GlobalSearchMobile v-if="show_search"/>
    <Banners :banners="banners"/>
    <MenuMobile :icon="true" :nav="true" :show_user="show_user"></MenuMobile>
  </div>
</template>

<script>
import Banners from '@/components/store/Banners'
export default {
  components: {Banners},
  props: {
    banners: {
      default: []
    },
    show_user: {
      type: Boolean,
      default: false
    },
    show_search: {
      type: Boolean,
      default: false
    }
  }
}
</script>
